var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import 'fomantic-ui-css/semantic.min.css'; // tslint:disable-line: no-import-side-effect
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { FetchClient } from '~/ApiClient';
import { Application } from '~/Application';
import { ConsoleErrorLogger, SentryErrorLogger } from '~/ErrorLogger';
import { loadGoogleTagManager } from '~/GoogleTagManager';
import '~/Styles/global.less'; // tslint:disable-line: no-import-side-effect
import '~/tailwind.css'; // tslint:disable-line: no-import-side-effect
// @ts-expect-error just putting COMMIT SHA to the window so that we know what's deployed
window.BUILD = process.env.APP_BUILD;
var isDevelopment = process.env.NODE_ENV === 'development';
var createConfig = function () { return ({
    contact: {
        supportEmail: 'support@cogvio.com',
    },
}); };
var createApiClientFactory = function () { return __awaiter(void 0, void 0, Promise, function () {
    var apiBaseUrl, MockClient_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                apiBaseUrl = (_a = process.env.API_BASE_URL) !== null && _a !== void 0 ? _a : 'https://mit-api.cogvio.com/v1/';
                if (!(isDevelopment && apiBaseUrl === 'mock')) return [3 /*break*/, 2];
                return [4 /*yield*/, import('~/ApiClient/MockClient')];
            case 1:
                MockClient_1 = (_b.sent()).MockClient;
                return [2 /*return*/, function (_) { return new MockClient_1(); }];
            case 2: return [2 /*return*/, function (handler) { return new FetchClient(apiBaseUrl, handler); }];
        }
    });
}); };
var main = function () { return __awaiter(void 0, void 0, void 0, function () {
    var errorLogger, application;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                errorLogger = typeof process.env.SENTRY_URL === 'string' && typeof process.env.APP_BUILD === 'string'
                    ? new SentryErrorLogger(process.env.SENTRY_URL, process.env.APP_BUILD)
                    : new ConsoleErrorLogger();
                return [4 /*yield*/, createApiClientFactory()];
            case 1:
                application = (<Application config={createConfig()} createApiClient={_c.sent()} errorLogger={errorLogger} pigeonAuthProvider={(_a = process.env.PIGEON_AUTH_PROVIDER) !== null && _a !== void 0 ? _a : 'app-mit-dev@cogvio.com'} pigeonBaseUrl={(_b = process.env.PIGEON_BASE_URL) !== null && _b !== void 0 ? _b : 'https://notifications-api.cogvio.com/api/v1/'}/>);
                ReactDOM.render(isDevelopment ? <React.StrictMode>{application}</React.StrictMode> : application, document.getElementById('application'));
                if (typeof process.env.GTM_CONTAINER_ID === 'string') {
                    loadGoogleTagManager(process.env.GTM_CONTAINER_ID);
                }
                return [2 /*return*/];
        }
    });
}); };
main();
